import { put, takeLatest } from 'redux-saga/effects';
import {
  getCreditListRequest,
  getCreditListSuccess,
  getCreditListFail,
  clearCreditList,
  adjustCreditRequest,
  adjustCreditSuccess,
  adjustCreditFail,
  setCreditListDirty,
  transferCreditRequest, transferCreditSuccess, transferCreditFail,
} from './actions';
import { logOut } from '../auth/actions';
import { apiCall } from '../../effects';
import { getErrorNotification } from '../../util';
import { notify } from '../notifications/actions';
import CreditService from '../../../services/CreditService';
import { getCurrentUserRequest, getUserRequest } from '../users/actions';
import history from '../../../history';

function* getCreditList({ payload }: ReturnType<typeof getCreditListRequest>) {
  try {
    const list = yield apiCall(CreditService.list, payload);
    yield put(getCreditListSuccess(list));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(getCreditListFail());
  }
}

function* adjustCredits({ payload }: ReturnType<typeof adjustCreditRequest>) {
  try {
    const adjustCreditResponse = yield apiCall(CreditService.adjustCredit, payload.user_id, payload);
    yield put(setCreditListDirty(true));
    yield put(adjustCreditSuccess(adjustCreditResponse));
    if (history.location.pathname.search('profile') !== -1) {
      yield put(getCurrentUserRequest());
    } else {
      yield put(getUserRequest(payload.user_id));
    }
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(adjustCreditFail());
  }
}

function* transferCredits({ payload }: ReturnType<typeof transferCreditRequest>) {
  try {
    const transferCreditResponse = yield apiCall(CreditService.transferCredit, payload.transfer_from_user_id, payload);
    yield put(setCreditListDirty(true));
    yield put(transferCreditSuccess(transferCreditResponse));
    if (history.location.pathname.search('profile') !== -1) {
      yield put(getCurrentUserRequest());
    } else {
      yield put(getUserRequest(payload.transfer_from_user_id));
    }
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(transferCreditFail());
  }
}

function* clearList() {
  yield put(clearCreditList());
}

export default [
  takeLatest(getCreditListRequest.type, getCreditList),
  takeLatest(adjustCreditRequest.type, adjustCredits),
  takeLatest(transferCreditRequest.type, transferCredits),
  takeLatest(logOut.type, clearList),
];
